import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Box, CircularProgress } from "@material-ui/core";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import { getFilteredResearchProposal } from "../../../reducer/researchProposal/action";
import dayjs from "dayjs";

function ListResearchProposal(props) {
  useEffect(() => {
    props.getFilteredResearchProposal(1, -1, {
      // accepted: true,
      dashboardYear: props.chosenYear,
      departmentId: props.chosenDepartmentId,
      acceptedOne: true,
    });
  }, [props.chosenYear]);

  // <option value="ministry_level_proposal">Viết đề xuất đề tài cấp Bộ, tương đương</option>
  //                 <option value="national_level_proposal">Viết đề xuất đề tài cấp Nhà nước, tương đương</option>
  //                 <option value="institutional_level_proposal">Viết đề xuất đề tài cơ sở</option>
  //                 <option value="ministry_level_explanation">Viết thuyết minh đề tài cấp Bộ và tương đương</option>
  //                 <option value="national_level_explanation">Viết thuyết minh đề tài cấp Quốc gia</option>
  //                 <option value="institutional_level_explanation">Viết thuyết minh đề tài cấp Trường</option>

  const getResearchProposalType = (type) => {
    switch (type) {
      case "ministry_level_proposal":
        return "Đề xuất đề tài cấp Bộ, tương đương";
      case "national_level_proposal":
        return "Đề xuất đề tài cấp Nhà nước, tương đương";
      case "institutional_level_proposal":
        return "Đề xuất đề tài cơ sở";
      case "ministry_level_explanation":
        return "Thuyết minh đề tài cấp Bộ và tương đương";
      case "national_level_explanation":
        return "Thuyết minh đề tài cấp Quốc gia";
      case "institutional_level_explanation":
        return "Thuyết minh đề tài cấp Trường";
      default:
        return "";
    }
  };

  const getResearchProposalTitle = (info, index) => {
    return (
      <div key={`researchProposal-${index}`} style={{ marginTop: 16 }}>
        <div>
          <b style={{ color: "gray" }}>
            {index + 1}. Tên {getResearchProposalType(info.researchProposal.type)}:{" "}
          </b>
          <i style={{ color: "red" }}> {info.researchProposal.title}</i>
        </div>
        <div style={{ marginLeft: 20 }}>
          <b>- Mã quản lý: </b>
          {info.researchProposal.code || ""}
          <br />
          <b>- Thời gian thực hiện: </b>
          {dayjs(info.researchProposal.workingTime).format("DD/MM/YYYY")}
          <br />
        </div>
      </div>
    );
  };

  return props.isFetching ? (
    <div style={{ textAlign: "center" }}>
      <CircularProgress />
    </div>
  ) : (
    <Box paddingRight={1} height="calc(100vh - 214px)" minWidth="calc(100% + 8px)" style={{ overflowY: "auto" }}>
      {props.listResearchProposalAccepted.map((item, index) => getResearchProposalTitle(item, index))}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  listResearchProposalAccepted: select(state, "researchProposalReducer", "listFiltered"),
  isFetching: select(state, "researchProposalReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  getFilteredResearchProposal: (page, pageSize, payload) =>
    dispatch(getFilteredResearchProposal(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ListResearchProposal));

